define([
	'internal_util/Util'
], function (
		Util
		) {
	'use strict';

	/**
	 * RequestedAttribute class
	 */
	return function (name, isRequired, purpose, origin) {
		var _name,
				_isRequired,
				_purpose = null,
				_origin = null;

		if (Util.isValidString(name)) {
			_name = name;
		} else {
			throw new Error('invalid requested attribute name: ' + name);
		}

		if (typeof isRequired === 'boolean') {
			_isRequired = isRequired;
		} else {
			throw new Error('invalid requested attribute isRequired value: ' + isRequired);
		}

		if (Util.isValidString(purpose)) {
			_purpose = purpose;
		}

		if (Util.isArray(origin)) {
			_origin = origin;
		} else {
			_origin = new Array();
		}


		// public methods

		this.name = function () {
			return _name;
		};

		this.isRequired = function () {
			return _isRequired;
		};

		this.purpose = function () {
			return _purpose;
		};

		this.origin = function () {
			return _origin;
		};

		this.toObject = function () {
			return {
				name: _name,
				isRequired: _isRequired,
				purpose: _purpose,
				origins: Util.serialize(_origin)
			};
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/RequestedAttribute.js
// module id = 40
// module chunks = 2